import Fetch from '@/utils/fetch';
import { Models } from '@mtap-smartcity/api';

export interface ReportsStatus {
  reports: Models.Reports.Report[];
  configs: Models.Reports.Config[];
}

export interface CreateReportRequest {
  object_display_name: string;
  filter_type: 'none' | 'object_id' | 'circuit_uuid' | 'group_uuid';
  filter_value: string;
  start_date: Date;
  end_date: Date;
  type: 'single' | 'scheduled';
  repeating_interval?: 'daily' | 'weekly' | 'monthly';
  created_by: string;
}

interface ReportExistsResponse {
  exists: boolean;
}

const getReportsStatus = (): Promise<ReportsStatus> => Fetch<ReportsStatus>('/api/bff/reports', { method: 'GET' });

const createReportConfig = (config: CreateReportRequest): Promise<Models.Reports.Config> => Fetch<Models.Reports.Config>('/api/bff/reports', { method: 'POST', body: config });

const downloadReportPdf = async (reportId: number): Promise<void> => {
  const token = localStorage.getItem('token');
  const response = await window.fetch(`/api/bff/reports/${reportId}/pdf`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to download PDF');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'report.pdf';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

const downloadReportXls = async (reportId: number): Promise<void> => {
  const token = localStorage.getItem('token');
  const response = await window.fetch(`/api/bff/reports/${reportId}/xls`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to download XLS');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'report.xls';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

const deleteReportConfig = (uuid: string): Promise<void> => Fetch<void>(`/api/bff/reports/${uuid}`, { method: 'DELETE' });

const checkReportsExistForConfig = (configUuid: string): Promise<ReportExistsResponse> => Fetch<ReportExistsResponse>(`/api/bff/reports/${configUuid}/exists`, { method: 'GET' });

const getReportsForConfig = (configUuid: string): Promise<Models.Reports.Report[]> => Fetch<Models.Reports.Report[]>(`/api/bff/reports/${configUuid}/reports`, { method: 'GET' });

export {
  getReportsStatus,
  createReportConfig,
  downloadReportPdf,
  downloadReportXls,
  deleteReportConfig,
  checkReportsExistForConfig,
  getReportsForConfig
};
